import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('linkedin-filled-circle-icon');
export var EmailFilledCircleIcon = function EmailFilledCircleIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 46 48"
  }, React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M23 0C18.451 0 14.0042 1.40758 10.2219 4.04473C6.43957 6.68188 3.4916 10.4302 1.75078 14.8156C0.0099655 19.201 -0.445511 24.0266 0.441949 28.6822C1.32941 33.3377 3.51995 37.6141 6.73656 40.9706C9.95317 44.327 14.0514 46.6128 18.5129 47.5388C22.9745 48.4649 27.599 47.9896 31.8017 46.1731C36.0044 44.3566 39.5965 41.2805 42.1238 37.3337C44.6511 33.3869 46 28.7467 46 24C46 17.6348 43.5768 11.5303 39.2635 7.02944C34.9501 2.52856 29.1 0 23 0ZM11.1818 17H11V30.3666L19.3257 23.891L11.1818 17ZM34.1856 31L25.8942 24.5511L23 27L20.1059 24.5511L11.8144 31H34.1856ZM26.6743 23.891L34.8182 17H35V30.3666L26.6743 23.891ZM12.73 17L20.646 23.6982L23 25.69L33.2701 17H12.73ZM36 16H35H34.4519H11.5481H11H10V17V31V32H11H35H36V31V17V16Z"
  }));
};